'use client';

import React, { useEffect } from 'react';
import Dialog from '../next-ui/Dialog';
import InKindDeliveryConfirmForm from './InKindDeliveryConfirmForm';
import InKindPledgeForm from './InKindPledgeForm';
import { fetchViaProxy } from '@/actions/proxy-fetch';
import ActivitySuccessDialog from '../ActivitySuccessDialog';
import useUserProfile from '@/hooks/useUserProfile';

const DonationStep = {
  pledge: 'pledge',
  confirmDelivery: 'confirmDelivery',
  success: 'success',
};

function DonateInKindDialog(props) {
  const {
    post,
    open,
    mode = 'donate',
    view = null,
    onClose,
    donationId,
  } = props;

  const [step, setStep] = React.useState(view || DonationStep.pledge);
  const [donation, setDonation] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState('');
  const [associatedNonProfit, setAssociatedNonProfit] = React.useState(null);

  const user = useUserProfile();

  const handleClose = (status) => {
    setStep(DonationStep.pledge);
    onClose(status || 0);
  };

  const updateNonProfit = async (nonProfit) => {
    setAssociatedNonProfit(nonProfit);
  };

  useEffect(() => {
    const fetchDonation = async () => {
      setLoading(true);
      const { data, ok } = await fetchViaProxy(
        `/proxy/v1/users/me/in-kind-donations/${donationId}`,
      );
      setLoading(false);

      if (ok) {
        setDonation(data?.data);
        setStep(DonationStep.confirmDelivery);
      } else {
        handleClose();
      }
    };
    if (mode === 'confirm-delivery') {
      if (donationId) {
        fetchDonation();
      } else {
        handleClose();
      }
    }
    if (view) {
      setStep(view);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [donationId, mode]);

  const handlePledge = (d) => {
    setDonation(d);
    setStep(DonationStep.confirmDelivery);
  };

  const handleConfirmation = (status) => {
    switch (status) {
      case 'confirmed':
        setSuccessMessage(
          'We are grateful for your donation! You should receive the receipt via email once the delivery is acknowledged.',
        );
        setStep(DonationStep.success);
        break;
      case 'confirm-later':
        if (mode === 'donate') {
          setSuccessMessage(
            'We have received your donation pledge. Please confirm once you deliver the goods.',
          );
          setStep(DonationStep.success);
        } else {
          handleClose();
        }
        break;
      case 'close':
        handleClose();
        break;
      default:
        break;
    }
  };

  const getTitle = () => {
    switch (step) {
      case DonationStep.pledge:
        return 'Donate In Kind';
      case DonationStep.confirmDelivery:
        return 'Confirm Delivery';
      case DonationStep.success:
        // return 'Thank You!';
        return '';
      default:
        return '';
    }
  };

  if (!post) {
    return null;
  }

  return (
    <Dialog
      title={getTitle()}
      isOpen={open}
      loading={loading}
      maxWidth="lg"
      onClose={handleClose}>
      {step === DonationStep.pledge && (
        <InKindPledgeForm post={post} onSubmit={handlePledge} />
      )}
      {step === DonationStep.confirmDelivery && donation && (
        <InKindDeliveryConfirmForm
          post={post}
          donation={donation}
          onSubmit={handleConfirmation}
          updateNonProfit={updateNonProfit}
        />
      )}
      {step === DonationStep.success && (
        <ActivitySuccessDialog
          // supportedNonProfit={selectedNonProfit}
          // nonProfit={profile?.nonProfitCompany}
          // company={profile?.company}
          nonProfit={associatedNonProfit}
          user={user}
          onClose={handleClose}
          isLoggedIn={user?.id > 0}
          message={successMessage}
          donate
        />
      )}
    </Dialog>
  );
}

export default DonateInKindDialog;
